
document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('.radio__buttons');
    const colorLabel = document.querySelector('.radio__legend__value');
    if (!container || !colorLabel) return;

    const originalText = colorLabel.textContent;

    container.addEventListener('mouseover', function (event) {
      const swatch = event.target.closest('.swatch--not-gift');
      if (swatch && swatch.dataset.tooltip) {
        colorLabel.textContent = swatch.dataset.tooltip;
      }
    });

    container.addEventListener('mouseout', function (event) {
      const swatch = event.target.closest('.swatch--not-gift');
      if (swatch) {
        colorLabel.textContent = originalText;
      }
    });
});